import React from "react";
import { Modal, Button } from "antd";
import { CheckOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";

export type StoreActionType = "approve" | "decline";

export type StoreActionConfirmModalProps = {
  open: boolean;
  action: StoreActionType;
  storeName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const StoreActionConfirmModal: React.FC<
  StoreActionConfirmModalProps
> = ({ open, action, storeName, loading = false, onClose, onConfirm }) => {
  const isApprove = action === "approve";
  const title = isApprove ? "Approve Store" : "Decline Store";
  const subtitle = isApprove
    ? `Are you sure you want to approve this store${storeName ? ` (${storeName})` : ""}?`
    : `Are you sure you want to decline this store${storeName ? ` (${storeName})` : ""}?`;
  const btnText = isApprove ? "Approve" : "Decline";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      destroyOnClose
      className={
        isApprove
          ? "store-action-modal store-action-modal--approve modal-round"
          : "store-action-modal store-action-modal--decline modal-round"
      }
      closeIcon={<CloseOutlined className="store-action-close-icon" />}
    >
      <div className="store-action-hero">
        <div className="store-action-hero-icon" aria-hidden>
          {isApprove ? <CheckOutlined /> : <DeleteOutlined />}
        </div>
        <div className="store-action-hero-wave" />
      </div>

      <div className="store-action-content">
        <div className="store-action-title">{title}</div>
        <div className="store-action-subtitle">
          {subtitle}
          <br />
          This action cannot be undone.
        </div>

        <Button
          type="primary"
          size="large"
          className={
            isApprove ? "store-action-btn store-action-btn--approve" : "store-action-btn store-action-btn--decline"
          }
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          {btnText}
        </Button>
      </div>
    </Modal>
  );
};

export default StoreActionConfirmModal;
